import React from 'react';

const TableWrap = ({ children }) => {
  return (
    <div className='table-wrap'>
      {children}
    </div>
  )
}

export default TableWrap;
